export default __webpack_public_path__ + "static/media/shield_check_outline.2ec97caf.svg";